import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "rounded-catering-md border border-catering-cream-300 bg-catering-cream-50 p-3 text-sm shadow-catering-xs" }
const _hoisted_2 = { class: "mb-1 text-catering-ink-700" }
const _hoisted_3 = {
  key: 0,
  class: "text-catering-ink-500"
}
const _hoisted_4 = { class: "space-y-1.5" }
const _hoisted_5 = { class: "flex items-baseline justify-between gap-2" }
const _hoisted_6 = { class: "min-w-0 truncate font-semibold text-catering-ink-900" }
const _hoisted_7 = { class: "shrink-0 tabular-nums text-catering-ink-700" }
const _hoisted_8 = { class: "text-xs text-catering-ink-500" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 0,
  class: "text-xs text-catering-ink-500"
}
const _hoisted_11 = { class: "mt-1 flex flex-wrap gap-1" }
const _hoisted_12 = {
  key: 0,
  class: "rounded bg-catering-honey-100 px-1.5 py-0.5 text-[11px] font-medium text-catering-honey-600"
}
const _hoisted_13 = {
  key: 1,
  class: "rounded bg-catering-berry-100 px-1.5 py-0.5 text-[11px] font-medium text-catering-berry-600"
}
const _hoisted_14 = {
  key: 2,
  class: "rounded bg-catering-cream-300 px-1.5 py-0.5 text-[11px] font-medium text-catering-ink-600"
}
const _hoisted_15 = {
  key: 3,
  class: "rounded bg-catering-cream-300 px-1.5 py-0.5 text-[11px] font-medium text-catering-ink-600"
}
const _hoisted_16 = {
  key: 4,
  class: "rounded bg-catering-cream-300 px-1.5 py-0.5 text-[11px] font-medium text-catering-ink-600"
}
const _hoisted_17 = {
  key: 5,
  class: "rounded bg-catering-cream-300 px-1.5 py-0.5 text-[11px] font-medium text-catering-ink-600"
}

import { computed } from 'vue'

// c.kind is what the code IS (a real discount, the referral program template,
// or a per-customer referral code). c.type is the discount mechanism
// ("Percentage Off") and drives a different label entirely.

export default {
  __name: 'BotDiscountCodeList',
  props: { block: { type: Object, required: true } },
  setup(__props) {

const KIND_LABELS = {
  referral: 'Referral',
  referral_template: 'Referral template'
}

const props = __props

// count is discount codes only and referral_count only ships when referral rows
// were requested, so the two are reported as separate figures rather than one
// number that would undercount the rows on screen.
const hasReferralCount = computed(() => typeof props.block.referral_count === 'number')

const kindLabel = kind => KIND_LABELS[kind] || null

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("p", { class: "mb-1 text-xs font-semibold uppercase tracking-wide text-catering-honey-600" }, "Discount codes", -1)),
    _createElementVNode("p", _hoisted_2, [
      _createTextVNode(_toDisplayString(__props.block.count) + " discount " + _toDisplayString(__props.block.count === 1 ? 'code' : 'codes') + " ", 1),
      (hasReferralCount.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, " · " + _toDisplayString(__props.block.referral_count) + " referral " + _toDisplayString(__props.block.referral_count === 1 ? 'code' : 'codes'), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("ul", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.block.codes || [], (c, i) => {
        return (_openBlock(), _createElementBlock("li", {
          key: i,
          class: "rounded-catering-md border border-catering-cream-300 bg-catering-cream-100 px-2.5 py-2"
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(c.code), 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(c.value), 1)
          ]),
          _createElementVNode("p", _hoisted_8, [
            _createTextVNode(_toDisplayString(c.type) + " ", 1),
            (c.name)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, "· " + _toDisplayString(c.name), 1))
              : _createCommentVNode("", true)
          ]),
          (c.requirements)
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(c.requirements), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_11, [
            (kindLabel(c.kind))
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(kindLabel(c.kind)), 1))
              : _createCommentVNode("", true),
            (c.status && c.status !== 'active')
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(c.status), 1))
              : _createCommentVNode("", true),
            (c.first_time_only)
              ? (_openBlock(), _createElementBlock("span", _hoisted_14, " first-time only "))
              : _createCommentVNode("", true),
            (c.auto_apply)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15, " auto-applies "))
              : _createCommentVNode("", true),
            (!c.combinable)
              ? (_openBlock(), _createElementBlock("span", _hoisted_16, " not combinable "))
              : _createCommentVNode("", true),
            (c.expiration_date)
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, " expires " + _toDisplayString(c.expiration_date), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

}